import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[piTesting]',
    standalone: false
})
/**
 * This directive can be used in place of a 'data-testing' attribute on an element.  When attached to an element
 * and an input is provided this directive will automatically add the 'data-testing' attribute to the element.
 *
 * @param {string} piTesting The value to be used as the 'data-testing' tag
 *
 * @example
 * //returns <div data-testing"testDiv" piTesting="testDiv"></div>
 * <div piTesting="testDiv"></div>
 */
export class PiTestingDirective implements OnInit {
    @Input()
    piTesting: string;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngOnInit() {
        if (this.piTesting) {
            this.renderer.setAttribute(
                this.el.nativeElement,
                'data-testing',
                this.piTesting
            );
        }
    }
}
